<template>
  <v-col cols="2" class="pa-1 mt-2 text-center">
    <v-card
      color="grey lighten-4"
      outlined
      class="pa-2"
      style="border: 1px solid"
    >
      <div
        v-if="controller.canDelete(step)"
        class="delete-badge"
        @click.prevent="controller.deleteStep(step)"
      >
        <v-icon color="error"> mdi-delete </v-icon>
      </div>
      <div class="check-badge" v-if="step.moduleRefId != 0">
        <v-icon color="success"> mdi-check </v-icon>
      </div>
      <v-img
        contain
        height="100px"
        :src="icon"
        @click.prevent="controller.assingWorkflowModule(step)"
      >
      </v-img>
    </v-card>
    <div class="action-description" v-html="labelDisplay"></div>
  </v-col>
</template>

<script>
export default {
  props: {
    step: Object,
    label: String,
    icon: String,
    ctrl: String,
  },
  data() {
    return {
      controller: this.get_controller(this.ctrl).sections.workflow_step,
    };
  },
  computed: {
    labelDisplay() {
      if (this.step.moduleRefId == 0) {
        return this.label;
      } else {
        return this.step.moduleRefName;
      }
    },
  },
  methods: {},
};
</script>

<style scoped>
.action-description {
  font-size: 14px;
  font-weight: bold;
  margin-top: 8px;
}

.delete-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  padding: 5px 10px;
  border-radius: 100%;
  background: white;
}

.check-badge {
  position: absolute;
  top: -10px;
  left: -10px;
  padding: 5px 10px;
  border-radius: 100%;
  background: white;
}
</style>